module.exports = function(app) {
    app.factory('youTubeService', ['$q', '$window', function($q, $window) {

        $('head').append('<script src="https://www.youtube.com/iframe_api"></script>');

        var apiDeferred = $q.defer();

        var resolveAPIDeferred = function() {
            apiDeferred.resolve();
        };

        if (!($window.YT && $window.YT instanceof Object)) {
            $window.onYouTubeIframeAPIReady = resolveAPIDeferred;
        }
        else if ($window.YT.loaded) {
            resolveAPIDeferred();
        }
        else {
            $window.YT.ready(resolveAPIDeferred);
        }

        return { getYouTubeAPI: apiDeferred.promise };
    }]);



    app.directive('youtubeVideoPlayer', function() {

        return {
            restrict: 'A',
            replace: true,

            scope: {
                video: '=youtubeVideoPlayer',
                onPlay: '&'
            },

            template:   '<div class="youtube-video-player">'+
                            '<div class="permission">' +
                               'You need to be able to access YouTube to watch these videos. Your firewall or internet access may block the site. Check your permissions to be sure.' +
                            '</div>'+
                        '</div>',

            controller: ['$scope', '$element', 'youTubeService',
                function($scope, $element, youTubeService) {
                    var video = $scope.video;
                    var videoWidth = video.width;
                    var videoHeight = video.height;

                    $element.css({"padding-bottom": (videoHeight / videoWidth * 100) + '%'});

                    var getVideoId = function(video) {
                        if (typeof video.embedUrl === 'string' && video.embedUrl.indexOf('embed/') >= 0) {
                            return video.embedUrl.split('embed/')[1];
                        }
                        else {
                            return video.embedUrl;
                        }
                    };

                    var videoId = getVideoId(video);
                    var divToReplace = $element.children()[0];
                    var player;


                    var onPlayerStateChange = function(event) {
                        if (event.data == 1) {
                            $scope.onPlay();
                        }
                    };


                    var makePlayer = function() {
                        player = new window.YT.Player(divToReplace, {
                            width: videoWidth,
                            height: videoHeight,
                            videoId: videoId,

                            playerVars: {
                                enablejsapi: 1,
                                autoplay: 0,
                                html5: 1,
                                showinfo: 1,
                                controls: 1,
                                rel: 0
                            },

                            events: {
                                'onStateChange': onPlayerStateChange
                            }
                        });

                        $scope.$watch('video.embedUrl', function(n, o) {
                            if (n !== o && player && player.cueVideoById instanceof Function) {
                                player.cueVideoById( getVideoId($scope.video) );
                            }
                        });
                    };


                    youTubeService.getYouTubeAPI.then(makePlayer);
                }]
            };
        }
    );
};
